import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { MarketingHero } from '../components/local-marketing/MarketingHero';
import { WorkflowSection } from '../components/local-marketing/WorkflowSection';
import { MarketingProductTour } from '../components/local-marketing/MarketingProductTour';
import { AudienceBuilder } from '../components/local-marketing/AudienceBuilder';
import { MarketingStrategies } from '../components/local-marketing/MarketingStrategies';
import { MarketingDemo } from '../components/local-marketing/MarketingDemo';
import { MarketingComparison } from '../components/local-marketing/MarketingComparison';
import { MarketingPricing } from '../components/local-marketing/MarketingPricing';
import { MarketingUseCases } from '../components/local-marketing/MarketingUseCases';
import { MarketingFAQ } from '../components/local-marketing/MarketingFAQ';
import { MarketingCta } from '../components/local-marketing/MarketingCta';
import { DatabaseIcon, BuildingIcon, BookOpenIcon, ScaleIcon } from 'lucide-react';
const marketingFeatures = [{
  title: 'Restaurant contacts database',
  description: 'Access restaurant contacts with reviews and ratings.',
  href: 'https://openmart.com/data/restaurants',
  cta: 'Explore restaurants',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Car dealer contacts database',
  description: 'Find car dealerships with location and contact info.',
  href: 'https://openmart.com/data/car-dealer',
  cta: 'Explore car dealers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Beauty salon contacts database',
  description: 'Access beauty salons with ratings and services.',
  href: 'https://openmart.com/data/beauty-salons',
  cta: 'Explore beauty salons',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'How to sell to local businesses',
  description: 'Strategies for targeting and closing local SMBs.',
  href: 'https://openmart.com/blogs/how-to-sell-to-local-business',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Landscaper contacts database',
  description: 'Access landscaping companies with verified details.',
  href: 'https://www.openmart.com/data/landscapers',
  cta: 'Explore landscapers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Openmart vs Apollo',
  description: 'Compare coverage, accuracy, and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-apollo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}];
export function LocalMarketing() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6920">
      <Navbar data-id="element-6921" />
      <main data-id="element-6922">
        <MarketingHero data-id="element-6923" />
        <TrustBar data-id="element-6924" />
        <WorkflowSection data-id="element-6925" />
        <MarketingProductTour data-id="element-6926" />
        <AudienceBuilder data-id="element-6927" />
        <MarketingStrategies data-id="element-6928" />
        <MarketingDemo data-id="element-6929" />
        <MarketingComparison data-id="element-6930" />
        <MarketingPricing data-id="element-6931" />
        <MarketingUseCases data-id="element-6932" />
        <MarketingFAQ data-id="element-6933" />
        <RelatedFeatures features={marketingFeatures} data-id="element-6934" />
        <MarketingCta data-id="element-6935" />
      </main>
      <Footer data-id="element-6936" />
    </div>;
}